import { Link } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { useDashboardMentions } from '../../api/dashboard.js';
import { EmptyState } from '../../components/EmptyState.js';
import { formatRelative } from '../invoices/format.js';

// REQ-FE-029c-2 — Wires to `GET /api/dashboard/mentions` (REQ-BE-029-be C).
// Returns recent @-mentions where the caller's email was tagged in a
// comment body. Default limit 20; mockup shows up to ~5 in the panel.
export function MentionsStream() {
  const q = useDashboardMentions(10);
  const rows = q.data ?? [];

  return (
    <section
      className="mentions-stream"
      data-testid="dashboard-mentions"
      aria-label="Mes mentions récentes"
    >
      <div className="eyebrow">Mes mentions récentes</div>
      {q.isLoading ? (
        <p className="muted" data-testid="dashboard-mentions-loading">
          Chargement…
        </p>
      ) : q.isError ? (
        <EmptyState
          testId="dashboard-mentions-error"
          variant="inline"
          icon="⚠️"
          title="Impossible de charger"
          description="Les mentions récentes n'ont pas pu être chargées."
        />
      ) : rows.length === 0 ? (
        <EmptyState
          testId="dashboard-mentions-empty"
          variant="inline"
          icon={<MessageSquare aria-hidden="true" size={18} strokeWidth={1.5} />}
          title="Aucune mention récente"
          description="Quand un collègue te mentionne dans un commentaire interne d'une facture (@email), la mention apparaîtra ici."
        />
      ) : (
        <ul className="mentions-stream__list" data-testid="dashboard-mentions-list">
          {rows.map((m) => (
            <li
              key={m.commentId}
              className="mentions-stream__row"
              data-testid={`dashboard-mention-${m.commentId}`}
            >
              <Link
                to={`/t/${m.tenantId}/invoices/${encodeURIComponent(m.invoicePrimaryKey)}`}
                className="mentions-stream__link"
              >
                <div className="mentions-stream__head">
                  <strong>{m.authorDisplayName ?? m.authorEmail ?? m.authorUid}</strong>
                  <span className="muted">
                    · {m.tenantName ?? m.tenantId.slice(0, 8)} · {formatRelative(m.createdAt)}
                  </span>
                </div>
                <div className="mentions-stream__body">{m.body}</div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
